/* TheSafeCase – composants de conversion (livraison estimée, ajout en un clic, note Noël).
   Chargé en defer depuis layout/theme.liquid. Aucune dépendance. */
(() => {
  'use strict';

  /* ---------- Jours ouvrés (week-ends + jours fériés fixes en France) ---------- */
  const FIXED_HOLIDAYS = ['01-01', '05-01', '05-08', '07-14', '08-15', '11-01', '11-11', '12-25'];
  const pad = (n) => String(n).padStart(2, '0');
  const isBusinessDay = (d) => {
    const day = d.getDay();
    if (day === 0 || day === 6) return false;
    return !FIXED_HOLIDAYS.includes(`${pad(d.getMonth() + 1)}-${pad(d.getDate())}`);
  };
  const addBusinessDays = (from, n) => {
    const r = new Date(from);
    while (n > 0) {
      r.setDate(r.getDate() + 1);
      if (isBusinessDay(r)) n--;
    }
    return r;
  };
  const fmt = (d, opts) => d.toLocaleDateString('fr-FR', opts || { weekday: 'short', day: 'numeric', month: 'short' });

  /* Dernier jour où l'on peut commander pour être livré au plus tard le 24/12 (délai max). */
  const christmasDeadline = (maxDays, now) => {
    const target = new Date(now.getFullYear(), 11, 24, 23, 59);
    const d = new Date(target);
    while (d > now) {
      if (isBusinessDay(d) && addBusinessDays(d, maxDays) <= target) return d;
      d.setDate(d.getDate() - 1);
    }
    return null;
  };

  const xmasLine = (maxDays, template) => {
    const now = new Date();
    if (now.getMonth() < 10) return null; // affiché à partir du 1er novembre seulement
    // +1 jour : couvre une commande passée après l'heure limite du jour
    const deadline = christmasDeadline(maxDays + 1, now);
    if (!deadline) return null; // date limite passée : on n'affiche rien (pas de fausse urgence)
    const label = fmt(deadline, { weekday: 'long', day: 'numeric', month: 'long' });
    return (template || 'Commande avant le {date} pour une livraison avant Noël').replace('{date}', label);
  };

  /* ---------- <tsc-delivery> ---------- */
  if (!customElements.get('tsc-delivery')) {
    customElements.define('tsc-delivery', class extends HTMLElement {
      connectedCallback() {
        const min = parseInt(this.dataset.min, 10) || 7;
        const max = Math.max(parseInt(this.dataset.max, 10) || 10, min);
        const cutoff = parseInt(this.dataset.cutoff, 10);
        let start = new Date();
        if (!isBusinessDay(start) || (!Number.isNaN(cutoff) && start.getHours() >= cutoff)) {
          start = addBusinessDays(start, 1); // commande traitée le jour ouvré suivant
        }
        const from = addBusinessDays(start, min);
        const to = addBusinessDays(start, max);
        const dates = this.querySelector('[data-dates]');
        if (dates) dates.innerHTML = `Entre le <strong>${fmt(from)}</strong> et le <strong>${fmt(to)}</strong>`;

        const line = this.querySelector('[data-xmas-line]');
        if (line && this.dataset.xmas === 'true') {
          const text = xmasLine(max, this.dataset.xmasText);
          if (text) { line.textContent = text; line.hidden = false; }
        }
      }
    });
  }

  /* ---------- <tsc-xmas-note> (bandeau accueil / Box) ---------- */
  if (!customElements.get('tsc-xmas-note')) {
    customElements.define('tsc-xmas-note', class extends HTMLElement {
      connectedCallback() {
        const text = xmasLine(parseInt(this.dataset.max, 10) || 10, this.dataset.text);
        if (text) { this.textContent = text; this.hidden = false; } else { this.hidden = true; }
      }
    });
  }

  /* ---------- <tsc-addon> : ajout en un clic d'un produit complémentaire ---------- */
  const readJson = (el, sel) => {
    try { return JSON.parse(el.querySelector(sel).textContent); } catch (e) { return {}; }
  };

  if (!customElements.get('tsc-addon')) {
    customElements.define('tsc-addon', class extends HTMLElement {
      connectedCallback() {
        this.main = readJson(this, 'script[data-main]');
        this.addons = readJson(this, 'script[data-addon]');
        this.checkbox = this.querySelector('[data-addon-checkbox]');
        this.modelEl = this.querySelector('[data-addon-model]');
        this.refresh = this.refresh.bind(this);
        this.form = document.getElementById(this.getAttribute('form-id'));
        if (this.form) {
          this.form.addEventListener('change', this.refresh);
          this.form.addEventListener('product:rerender', () => setTimeout(this.refresh, 50));
        }
        document.addEventListener('variant:change', this.refresh);
        this.refresh();
      }
      disconnectedCallback() {
        document.removeEventListener('variant:change', this.refresh);
      }
      /* Variante du produit complémentaire qui correspond au modèle choisi */
      match() {
        if (this.dataset.single) return { id: this.dataset.single, available: true };
        if (!this.form || !this.form.elements.id) return null;
        const key = this.main[this.form.elements.id.value];
        const found = key !== undefined ? this.addons[key] : null;
        return found && found.available ? found : null;
      }
      refresh() {
        const m = this.match();
        this.hidden = !m;
        if (!m && this.checkbox) this.checkbox.checked = false;
        if (this.modelEl && m && !this.dataset.single) {
          const key = this.main[this.form.elements.id.value] || '';
          this.modelEl.textContent = key ? `Compatible avec ton iPhone ${key.replace(/promax/i, ' Pro Max').replace(/pro$/i, ' Pro').replace(/plus$/i, ' Plus').trim()}` : '';
          this.modelEl.hidden = !key;
        }
      }
      selected() {
        return this.checkbox && this.checkbox.checked ? this.match() : null;
      }
    });
  }

  /* Interception du submit (phase de capture, avant le gestionnaire du thème) :
     si la case est cochée, on envoie les deux articles via items[] à /cart/add.js. */
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    // Attention : form.id renvoie l'<input name="id"> sur un formulaire produit, d'où getAttribute.
    const formId = form.getAttribute('id');
    if (!formId || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    const addonEl = document.querySelector(`tsc-addon[form-id="${CSS.escape(formId)}"]`);
    const addon = addonEl && addonEl.selected();
    if (!addon || !form.elements.id) return;

    const disabled = [];
    const box = document.createElement('div');
    box.hidden = true;
    const add = (name, value) => {
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = name; input.value = value;
      box.appendChild(input);
    };

    // Article principal
    add('items[][id]', form.elements.id.value);
    const qty = form.querySelector('[name="quantity"]');
    add('items[][quantity]', qty && qty.value ? qty.value : 1);
    Array.from(form.elements).forEach((el) => {
      if (!el.name || el.disabled) return;
      const isProp = el.name.startsWith('properties[');
      const isPlan = el.name === 'selling_plan';
      if (isProp && (el.type !== 'checkbox' || el.checked)) add(`items[]${el.name.replace(/^properties/, '[properties]')}`, el.value);
      if (isPlan && el.value) add('items[][selling_plan]', el.value);
      if (el.name === 'id' || el.name === 'quantity' || isProp || isPlan) { el.disabled = true; disabled.push(el); }
    });
    // Article complémentaire
    add('items[][id]', addon.id);
    add('items[][quantity]', 1);

    form.appendChild(box);
    // Le thème construit son FormData de façon synchrone : on restaure juste après.
    setTimeout(() => {
      box.remove();
      disabled.forEach((el) => { el.disabled = false; });
    }, 0);
  }, true);


  /* Bouton « Acheter maintenant » des cartes produit : ajoute l'article puis envoie au paiement. */
  if (!customElements.get('tsc-buy-now')) {
    customElements.define('tsc-buy-now', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button || this.bound) return;
        this.bound = true;
        this.button.addEventListener('click', () => this.buy());
      }
      async buy() {
        const formId = this.getAttribute('form-id');
        const form = formId ? document.getElementById(formId) : this.closest('form');
        if (!form || this.button.getAttribute('aria-busy') === 'true') return;
        if (!form.checkValidity()) { form.reportValidity(); return; }
        this.button.setAttribute('aria-busy', 'true');
        let data = new FormData(form);
        data.delete('on_success');
        // Fiche produit : si la case « verre trempé » est cochée, on envoie les deux articles.
        const addonEl = formId ? document.querySelector(`tsc-addon[form-id="${CSS.escape(formId)}"]`) : null;
        const addon = addonEl && addonEl.selected && addonEl.selected();
        if (addon && data.get('id')) {
          const multi = new FormData();
          multi.append('items[][id]', data.get('id'));
          multi.append('items[][quantity]', data.get('quantity') || 1);
          for (const [k, v] of data.entries()) {
            if (k.startsWith('properties[')) multi.append(`items[]${k.replace(/^properties/, '[properties]')}`, v);
            if (k === 'selling_plan' && v) multi.append('items[][selling_plan]', v);
          }
          multi.append('items[][id]', addon.id);
          multi.append('items[][quantity]', 1);
          data = multi;
        }
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        try {
          const res = await fetch(`${root}cart/add.js`, { method: 'POST', body: data, headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } });
          if (res.ok) { window.location.href = `${root}checkout`; return; }
          const json = await res.json().catch(() => ({}));
          this.showError(json.description || json.message || 'Ce modèle n’est plus disponible.');
        } catch (e) {
          this.showError('Connexion impossible, réessaie dans un instant.');
        }
        this.button.removeAttribute('aria-busy');
      }
      showError(message) {
        let el = this.parentElement.querySelector('.tsc-card-buy__error');
        if (!el) { el = document.createElement('p'); el.className = 'tsc-card-buy__error'; el.setAttribute('role', 'alert'); this.insertAdjacentElement('afterend', el); }
        el.textContent = message;
      }
    });
  }


  /* Barre « Ton pack » : renvoyée avec chaque ajout ou changement du panier, puis remplacée sans rechargement. */
  const PACKBAR = 'tsc-pack-bar';
  document.addEventListener('cart:prepare-bundled-sections', (event) => {
    if (document.querySelector('[data-tsc-packbar]') && event.detail && Array.isArray(event.detail.sections) && !event.detail.sections.includes(PACKBAR)) {
      event.detail.sections.push(PACKBAR);
    }
  });
  const swapPackbar = (html) => {
    const current = document.querySelector('[data-tsc-packbar]');
    if (!current || !html) return;
    const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-tsc-packbar]');
    if (!next) return;
    const grew = (parseInt(next.dataset.count, 10) || 0) > (parseInt(current.dataset.count, 10) || 0);
    current.replaceWith(next);
    if (grew) { void next.offsetWidth; next.classList.add('is-bump'); }
  };
  document.addEventListener('cart:change', async (event) => {
    if (!document.querySelector('[data-tsc-packbar]')) return;
    const sections = event.detail && event.detail.cart && event.detail.cart.sections;
    if (sections && sections[PACKBAR]) { swapPackbar(sections[PACKBAR]); return; }
    try {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const res = await fetch(`${root}?sections=${PACKBAR}`);
      if (res.ok) swapPackbar((await res.json())[PACKBAR]);
    } catch (e) { /* la barre se mettra à jour au prochain chargement */ }
  });

})();
